import { TGuestRatingInfo } from '../../types/guestRating';

export function guestRatingInfoReducer(state: TGuestRatingInfo): TGuestRatingInfo {
  return state || null;
}
